module.exports = __webpack_public_path__ + "img/dec-letter_left.d9ec4c66.png";